import { useCallback, useRef } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { TrustPain } from "@/components/landing/TrustPain";
import { Industries } from "@/components/landing/Industries";
import { Workflow } from "@/components/landing/Workflow";
import { Outcomes } from "@/components/landing/Outcomes";
import { EnquiryForm } from "@/components/landing/EnquiryForm";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  const enquiryRef = useRef(null);

  const scrollToEnquiry = useCallback(() => {
    enquiryRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className="min-h-screen bg-white text-brand-slate" data-testid="landing-page">
      <Navbar onCta={scrollToEnquiry} />
      <main>
        <Hero onCta={scrollToEnquiry} />
        <TrustPain />
        <Industries />
        <Workflow />
        <Outcomes />

        <section
          id="enquiry"
          ref={enquiryRef}
          className="bg-brand-cream py-24 md:py-32"
          data-testid="enquiry-section"
        >
          <div className="max-w-6xl mx-auto px-6 md:px-10">
            <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
              <p
                className="text-[11px] md:text-[13px] uppercase tracking-[0.45em] text-brand-navy/50 mb-4"
                data-testid="enquiry-eyebrow"
              >
                See it in action
              </p>
              <h2
                className="font-poppins font-semibold text-brand-navy text-3xl md:text-5xl tracking-tight leading-tight"
                data-testid="enquiry-heading"
              >
                See how compliance runs itself.
              </h2>
              <p className="mt-5 text-brand-slate/80 leading-relaxed">
                Book a 30-minute walkthrough. We'll show you how Vanguard Beacon fits into
                your daily operations and turns audit prep from days into minutes.
              </p>
            </div>
            <div className="max-w-3xl mx-auto">
              <EnquiryForm />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
